module.exports = ".mask{\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 10;\n    background: rgba(238, 238, 238, 0.15);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trip/trip-view/trip-view.component.css
// module id = ./src/app/components/trip/trip-view/trip-view.component.css
// module chunks = main